import classNames from 'classnames';
import { ReactNode } from 'react';

type ProductInfoLabelProps = {
  children: ReactNode;
  className?: string;
  trailing?: ReactNode;
};

export const ProductInfoLabel = ({
  children,
  className,
  trailing,
}: ProductInfoLabelProps) => {
  return (
    <span
      className={classNames(
        'inline-flex items-center gap-0.5 rounded-sm bg-neutral-1 px-2 py-1 text-xs leading-4 text-neutral-6',
        className,
      )}
    >
      {children}
      {trailing}
    </span>
  );
};
